/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/no-var-requires */ import "./i18n";
import { installGatewayAuth } from "@Auth/session";
import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginReact from "@bugsnag/plugin-react";
import { getAuthConfig } from "@Config/auth";
import { initDatadog } from "@Config/datadog";
import { env } from "@Config/env";
import { followWordTheme } from "@Styles/wordTheme";
import * as React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./components/App";
const rootElement = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;
// KEEP THIS HERE - IT WILL MAKE SURE THE ENVIRONMENT IS SET UP CORRECTLY
// ELSE THE APP WILL NOT WORK PROPERLY
const checkEnv = env;
if (checkEnv.isProduction) {
    Bugsnag.start({
        apiKey: "e04911f5494fcfc36f3402cad5f3b473",
        appVersion: process.env.npm_package_version,
        plugins: [
            new BugsnagPluginReact()
        ]
    });
    BugsnagPerformance.start({
        apiKey: "e04911f5494fcfc36f3402cad5f3b473"
    });
}
installGatewayAuth();
const ErrorBoundary = Bugsnag.getPlugin("react")?.createErrorBoundary(React);
function AppWithErrorHandling() {
    if (checkEnv.isProduction && ErrorBoundary) {
        return /*#__PURE__*/ React.createElement(ErrorBoundary, null, /*#__PURE__*/ React.createElement(App, null));
    }
    return /*#__PURE__*/ React.createElement(App, null);
}
Office.onReady(async ()=>{
    followWordTheme();
    if (checkEnv.isProduction) {
        try {
            const authConfig = await getAuthConfig();
            initDatadog(authConfig);
        } catch (e) {
            console.error("Failed to initialize Datadog", e);
        }
    }
    root?.render(/*#__PURE__*/ React.createElement(AppWithErrorHandling, null));
});
if (module.hot) {
    module.hot.accept("./components/App", ()=>{
        const NextApp = require("./components/App").default;
        root?.render(NextApp);
    });
}
